import React, { useState, useRef, useEffect } from 'react';
import IconButton from '../buttons/IconButton';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modal';
import { IMAGES } from 'assets/images';

interface ClickPopupProps {
  title?: string;
  text: string;
  video?: string;
  image?: string;
}

const ClickPopup: React.FC<ClickPopupProps> = ({
  text,
  video,
  image,
  title = 'Hint',
}) => {
  const [visible, setVisible] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  // Handle the button click to show the popup
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setVisible(true);
  };

  // Listen for clicks outside the popup and hide it if clicked
  const handleDocumentClick = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener('mousedown', handleDocumentClick);
    } else {
      document.removeEventListener('mousedown', handleDocumentClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, [visible]);

  return (
    <>
      <IconButton
        type="transparent"
        icon={faQuestionCircle}
        onClick={handleButtonClick}
        color="white"
      />
      <Modal isOpen={visible} onClose={() => setVisible(false)}>
        <div
          className="user-alert-popup"
          style={{
            minWidth: 'min(1000px, 95vw)',
            color: 'var(--gray-10)',
            alignItems: 'top',
          }}
        >
          <div className="row" style={{ alignItems: 'top' }}>
            <img src={IMAGES.characters.wormy_hint} alt="Orator" />
            <div
              className="col"
              style={{
                textAlign: 'left',
                marginTop: '2%',
                gap: '20px',
                alignSelf: 'stretch',
              }}
            >
              <label className="label-large">
                <strong>{title}</strong>
              </label>
              <span className="label-normal">{text}</span>
            </div>
            {image && (
              <img
                className="hint-media"
                src={image}
                alt="popup media"
                // style={{ maxWidth: '50%', maxHeight: '100%' }}
              />
            )}
            {video && (
              <video
                className="hint-media"
                src={video}
                controls
                style={{ maxWidth: '50%', maxHeight: '100%' }}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ClickPopup;
